/**
 * The answers the plan was approved with, at the top of the plan on the
 * record (a running build, a paused run, a finished ticket).
 *
 * One line per answered question, in the stated decisions' grammar: the
 * question, then who answered and the answer, and an alternative's own
 * reason. Since answers edit the plan before approval (spec 2026-11-02), the
 * plan beneath is the one the answers made, so no line says it was written
 * for another option.
 *
 * Read from the approval's own record (`approvedPlanAnswers`), never inferred:
 * a question with no recorded answer is not drawn.
 */
import type { ApprovedPlanAnswers } from "./planAnswerNotes.js";

export function PlanAnswersRecord({ record }: { record: ApprovedPlanAnswers }) {
  const rows = record.questions.flatMap((question) => {
    const answer = record.answers.find((entry) => entry.questionId === question.id);
    return answer ? [{ question, answer }] : [];
  });
  if (rows.length === 0) return null;
  return (
    <div className="decided" data-testid="plan-answers-record">
      {rows.map(({ question, answer }) => {
        const alternative = question.alternatives.find(
          (option) => option.answer.trim() === answer.answer.trim(),
        );
        return (
          <div key={question.id} data-testid="plan-answer-record">
            <div className="dl">
              <span className="dq">
                <span className="qq">{question.text}</span>
                <span className="aa">
                  <span className="by">{answer.byReeve ? "Reeve chose" : "Answered"}</span>
                  {answer.answer}
                </span>
                {alternative?.why && <span className="cw">{alternative.why}</span>}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
